module.exports = __webpack_public_path__ + "img/eg-20-01.337d798b.jpg";